<script>
import { HMIS_USERNAME } from "@/plugins/vars";
export default {
    name: "LogIn",

    data() {

        return {
          otptimer:0,
          countdownHasStopped:false,
          resendotp:0,
          userloginoption:'1',
          login: {
            username: '',
            password: '',
            onTimePas: '',
            entity:0,
          },
          logresponse: {
            message: '',
            logI: '',
            entity: 0,
          },
          minutes: 3, // starting minutes
      totalSeconds: 0,
      timer: null,
          // userActivityModels: {
          //   userHostName: '',
          //   userHostAddress: '',
          //   userActivity: '',
          //   userName:  '',
                
          //   },
          showotp:false,
        };
    },
    computed: {
      formattedTime() {
      const m = Math.floor(this.totalSeconds / 60);
      const s = this.totalSeconds % 60;
      return `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
    }
  },

    mounted() {
    this.GetLoginOption();
   
},
   
//   mounted() {
//     this.totalSeconds = this.minutes * 60;
//     this.startCountdown();
   
// },beforeUnmount() {
//     clearInterval(this.timer);
//   },
    methods: {
      
          GetLoginOption() {
            let url = `UserAccount/GetLoginOption`;

            return this.$http.get(url).then(({ data }) => {
                this.userloginoption = data;
            }).catch(() => {});
        },
      startCountdown() {
      this.timer = setInterval(() => {
        if (this.totalSeconds > 0) {
          this.totalSeconds--;
        } else {
          clearInterval(this.timer);
          this.countdownHasStopped = true;
           this.$emit('finished');
        }
      }, 1000);
    },
      logIn() {
          this.$root.loading = true;
          this.$http.get(`UserAccount/LoginAdvance?UserName=${this.login.username}&Password=${this.login.password}`).then(response => {
        //    this.$http.get(`UserAccount/Login?UserName=${this.login.username}&Password=${this.login.password}`).then(response => {
            // this.login.password = '';
            if(!response.data) {

              this.$root.loading = false;
              window.Swal.fire({ type: `error`, text: `Invalid credentials.`});

              return;
            }
            window.Cookies.set(HMIS_USERNAME, this.login.username, { expires: 0.75 });
            this.fetchCompanydetails(),
            this.fetchCompanyCOnfigs(),
            this.fetchRights().then(() => {
              this.$root.loading = false;
              //  window.location.replace('/');
               // this.$router.push({name: 'home.home-dashboard.index'});
               window.location.replace('/home/home-dashboard');
            
            });
          }).catch(() => {
            this.$root.loading = false;
          });
        },
          logInB4Otp() {
          this.$root.loading = true;
          this.$http.get(`UserAccount/LoginAdvanceOt?UserName=${this.login.username}&Password=${this.login.password}&Entity=${this.login.entity}&onTimePas=${this.login.onTimePas}`).then(response => {
        //    this.$http.get(`UserAccount/Login?UserName=${this.login.username}&Password=${this.login.password}`).then(response => {
            // this.login.password = '';
            this.logresponse=response.data
            if(!this.logresponse.userOk) {

              this.$root.loading = false;
              window.Swal.fire({ type: `error`, text: `Invalid credentials.`});

              return;
            }
            this.$root.loading = false;
            
            if(this.logresponse.logI==0){
            //  window.Cookies.set(HMIS_USERNAME, this.login.username, { expires: 0.75 });
              window.Cookies.set(HMIS_USERNAME, this.logresponse.userName, { expires: 0.75 });
              this.fetchCompanydetails(),
            this.fetchCompanyCOnfigs(),
            this.fetchRights().then(() => {
              this.$root.loading = false;
              this.$root.RecordUserActivity(this.logresponse.userName,'User Login: Successfuly Logged In');
            //  this.RecordUserActivity(this.login.username),
            //  window.location.replace('/');
               // this.$router.push({name: 'home.home-dashboard.index'});
               window.location.replace('/home/home-dashboard');
               this.showotp=false;
               this.login.entity=1;
            });
            }else{
              this.login.entity=1;
              this.showotp=true;
              this.totalSeconds = this.minutes * 60;
    this.startCountdown();
            }
           
          }).catch(() => {
            this.$root.loading = false;
          });
        },

        ResendOtp() {
          this.login.entity=0;
         this.resendotp=1;
         
          this.logInB4Otp();
        },fetchRights() {
          let url = `Admin/GetAllUserRights`;
              url += `?UserName=${window.Cookies.get(HMIS_USERNAME).toLowerCase()}`;

          return this.$http.get(url).then(({ data }) => {
              window.localStorage.setItem('P_102', window.JSON.stringify(data));
          }).catch(() => {});
        },
         fetchCompanydetails() {
          let url = `MasterData/GetCompanyDetails`;
             

           this.$http.get(url).then(({ data }) => {
              window.localStorage.setItem('P_103', window.JSON.stringify(data[0]));
          }).catch(() => {});
        }, fetchCompanyCOnfigs() {
          let url = `MasterData/GetCompanyConfigs`;
             

           this.$http.get(url).then(({ data }) => {
              window.localStorage.setItem('P_104', window.JSON.stringify(data));
              //  companyconfigsprintprescriptionstamp:JSON.parse(localStorage.getItem('P_104'))[5].valueBit?JSON.parse(localStorage.getItem('P_104'))[5].valueBit:false,
   // companyconfigsprintinvoicestamp:JSON.parse(localStorage.getItem('P_104'))[4].valueBit?JSON.parse(localStorage.getItem('P_104'))[4].valueBit:false,
    //companyconfigsprintadmissiononinvoice:JSON.parse(localStorage.getItem('P_104'))[3].valueBit?JSON.parse(localStorage.getItem('P_104'))[3].valueBit:false,
   // companyconfigsprintdateoninvoice:JSON.parse(localStorage.getItem('P_104'))[2].valueBit?JSON.parse(localStorage.getItem('P_104'))[2].valueBit:false,
    //companyconfigsdocumentvisitupload:JSON.parse(localStorage.getItem('P_104'))[0].valueBit?JSON.parse(localStorage.getItem('P_104'))[0].valueBit:false,

          }).catch(() => {});
        },
        RecordUserActivity(username) {
          var userActivityModels={
            userActivity:"User Login: "+username+": Successfully Logged In",
            userHostAddress:window.location.host,
            userHostName:window.location.hostname,
             userName:username,
          }
          // this.userActivityModels.userActivity="User Login: "+username+": Successfully Logged In";
          // this.userActivityModels.userHostAddress=window.location.host;
          // this.userActivityModels.userHostAddress=window.location.hostname;
          // this.userActivityModels.userName=username;
          
          this.$root.loading = true;
                this.$http.post(`Admin/RecordUserActivity`, userActivityModels).then(response => {
                     
                  this.responsemsg= response.data;
                    this.$root.loading = false;
                 }).catch(() => { this.$root.loading = false; });

          
        }
    },

}
</script>
<template>
   <div class="w-full flex justify-center h-screen bg-teal-500 p-10">
        
        <form @submit.prevent="logInB4Otp" class="md:w-1/3 sm:w-full self-center bg-gray-200 shadow-md rounded px-4 pt-6 pb-8 mb-4">
          <!-- <div class="justify-center">
               <img class="text-center" src="../../assets/medprimelogo.png"> 
            </div>  -->
            <div class="flex-1 content-between mb-4">
                <h4 class="text-center font-medium text-xl"><i class="fa fa-key"></i> SIGN IN</h4>
            </div>
          <div class="flex-1 mb-2" v-if="showotp==0">
            <label class="label-control" for="username" v-if="userloginoption=='1'">
              Username
            </label><label class="label-control" for="username" v-if="userloginoption=='2'">
              National Id
            </label><label class="label-control" for="username" v-if="userloginoption=='3'">
              Email
            </label>
            
            <input v-model.trim="login.username" required class="input-control leading-tight focus:outline-none focus:shadow-outline" id="username" type="text" placeholder="Username">
          </div>
          <div class="flex-1 mb-3" v-if="showotp==0">
            <label class="label-control" for="password">
              Password
            </label>
            <input v-model="login.password" required class="input-control leading-tight focus:outline-none focus:shadow-outline" id="password" type="password">
          </div>
          <div class="flex items-center justify-between" v-if="showotp==0">
            <button class="flex-1 block bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline" type="submit">
              Sign In
            </button>
          </div>
          <div class="flex-1 mb-3" v-if="showotp==1 && !countdownHasStopped">
            <label class="label-control" for="otp">
              Enter OTP
            </label>
            <input v-model="login.onTimePas" required class="input-control leading-tight focus:outline-none focus:shadow-outline" id="otp" type="text">
          </div>
          <div class="flex items-center justify-between" v-if="showotp==1 && !countdownHasStopped">
            <button class="flex-1 block bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline" type="submit">
              Confirm Otp
            </button>
          </div>
          <div class="flex items-center justify-between mt-2" v-if="showotp==1 ">
            <button
                          @click.prevent="ResendOtp"
                          class="flex-1 block bg-orange-500 hover:bg-orange-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                        >
                        Resend OTP
                        </button> 
          </div> 
          <div class="flex-1 content-between mb-4 mt-3 " v-if="showotp==1 && !countdownHasStopped">
                <h4 class="text-center font-medium text-xl text-blue-500">Otp Expiry: {{formattedTime }}</h4>
            </div> <div class="flex-1 content-between mb-4 mt-3 " v-if="showotp==1 && countdownHasStopped">
                <h4 class="text-center font-medium text-xl text-blue-500">Otp Expired</h4>
            </div>
          <p class="text-center text-gray-500 text-xs mt-6">
            &copy; {{ new Date().getFullYear() }}
          </p>
        </form>
        
    </div>
</template>
